import script from "./SelectEventType.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectEventType.vue?vue&type=script&setup=true&lang=ts"

import "./SelectEventType.vue?vue&type=style&index=0&id=1a9b079e&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a9b079e"]])

export default __exports__